var _hmt = _hmt || []
window._hmt = _hmt
  ; (function () {
    var hm = document.createElement('script')
    hm.src = (process.env.NODE_ENV == "production")
      ? 'https://hm.baidu.com/hm.js?5eebe30de5a392c5d4ed32c1b1408bb3'
      : 'https://hm.baidu.com/hm.js?4c268d9125e6736d49653918c3ed0cbf';
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm,s)
  })()
